var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUserCircle = function SvgUserCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 3a9 9 0 0 0-6.862 14.824A4.99 4.99 0 0 1 9 16h6a4.99 4.99 0 0 1 3.862 1.824A9 9 0 0 0 12 3m7.37 17.166A10.97 10.97 0 0 0 23 12c0-6.075-4.925-11-11-11S1 5.925 1 12a10.97 10.97 0 0 0 3.665 8.198A10.96 10.96 0 0 0 12 23a10.96 10.96 0 0 0 7.37-2.834M17.4 19.2A3 3 0 0 0 15 18H9c-.98 0-1.853.47-2.4 1.2A8.96 8.96 0 0 0 12 21a8.96 8.96 0 0 0 5.4-1.8M12 6.5a3 3 0 1 0 0 6 3 3 0 0 0 0-6m-5 3a5 5 0 1 1 10 0 5 5 0 0 1-10 0",
    clipRule: "evenodd"
  })));
};
export default SvgUserCircle;